import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon, BookOpenIcon, VideoIcon, AppleIcon, HomeIcon, HeartPulseIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-navy text-white" data-id="element-98">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-99">
        {/* The Unique Mechanism */}
        <FadeIn data-id="element-100">
          <div className="text-center mb-16" data-id="element-101">
            <ShieldCheckIcon className="w-16 h-16 text-teal mx-auto mb-6" data-id="element-102" />
            <h2 className="text-h2 text-white mb-6" data-id="element-103">El Método RIIC</h2>
            <p className="text-teal font-bold text-xl mb-8 tracking-wide uppercase" data-id="element-104">
              Resistencia Isométrica de Impacto Cero
            </p>
            <div className="text-body-lg text-cream/90 max-w-3xl mx-auto space-y-6 text-left" data-id="element-105">
              <p data-id="element-106">
                A diferencia del ejercicio convencional que requiere mover
                articulaciones o saltar, la técnica RIIC utiliza la tensión
                muscular estática contra puntos fijos (como una pared o una
                silla).
              </p>
              <p data-id="element-107">
                Esto crea una presión interna segura que envía una señal
                eléctrica a tus huesos para que absorban minerales y se
                fortalezcan, sin poner en riesgo tus rodillas o espalda. Es
                "ejercicio sin movimiento" diseñado específicamente para la
                densidad ósea.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* What You Get */}
        <FadeIn delay={0.2} data-id="element-108">
          <div className="bg-white text-charcoal rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-109">
            <h3 className="text-h2 text-center mb-12" data-id="element-110">Lo que obtienes hoy</h3>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-111">
              {[{
              icon: BookOpenIcon,
              title: 'La Guía Digital "Huesos Invencibles"',
              desc: 'Con el paso a paso del método RIIC.'
            }, {
              icon: VideoIcon,
              title: 'Rutina Visual de 15 Minutos',
              desc: '5 ejercicios clave para realizar en casa sin equipo.'
            }, {
              icon: AppleIcon,
              title: 'Protocolo Nutricional',
              desc: 'Las vitaminas "olvidadas" que realmente fijan el calcio.'
            }, {
              icon: HomeIcon,
              title: 'Auditoría de Hogar Seguro',
              desc: 'Checklist para eliminar riesgos de caídas en 2 minutos.'
            }, {
              icon: HeartPulseIcon,
              title: 'Guía de Emergencia',
              desc: 'Cómo levantarse del suelo correctamente en caso de tropezón.'
            }].map((item, i) => <div key={i} className="flex gap-4 items-start" data-id="element-112">
                  <div className="bg-teal/10 p-3 rounded-full text-teal-dark flex-shrink-0" data-id="element-113">
                    <item.icon className="w-6 h-6" data-id="element-114" />
                  </div>
                  <div data-id="element-115">
                    <h4 className="font-bold text-lg text-navy mb-1" data-id="element-116">
                      {item.title}
                    </h4>
                    <p className="text-body text-charcoal/80" data-id="element-117">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* How It Works */}
        <FadeIn delay={0.3} className="mt-24" data-id="element-118">
          <h3 className="text-h2 text-white text-center mb-12" data-id="element-119">
            Cómo funciona
          </h3>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-120">
            {[{
            step: '1',
            text: 'Abre la guía y sigue las ilustraciones detalladas de los 5 ejercicios RIIC.'
          }, {
            step: '2',
            text: 'Dedica 15 minutos cada mañana a realizar la rutina usando solo una pared o una silla.'
          }, {
            step: '3',
            text: 'Aplica los cambios nutricionales simples para asegurar que tus huesos tengan el material de construcción necesario.'
          }].map((item, i) => <div key={i} className="text-center" data-id="element-121">
                <div className="w-16 h-16 rounded-full bg-teal text-navy text-2xl font-bold flex items-center justify-center mx-auto mb-6" data-id="element-122">
                  {item.step}
                </div>
                <p className="text-body text-cream/90" data-id="element-123">{item.text}</p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}